<template>
    <component is="blank-layout">
        <router-view></router-view>
    </component>
</template>
